import { render, staticRenderFns } from "./Jgrw.vue?vue&type=template&id=7030885c&"
import script from "./Jgrw.vue?vue&type=script&lang=js&"
export * from "./Jgrw.vue?vue&type=script&lang=js&"
import style0 from "./Jgrw.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports